import { render, staticRenderFns } from "./suggest-a-resource.vue?vue&type=template&id=72cbfdc8&scoped=true"
import script from "./suggest-a-resource.vue?vue&type=script&lang=js"
export * from "./suggest-a-resource.vue?vue&type=script&lang=js"
import style0 from "./suggest-a-resource.vue?vue&type=style&index=0&id=72cbfdc8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cbfdc8",
  null
  
)

export default component.exports